/* eslint-disable eqeqeq */
import { useStepper } from "../../../../components/ui/stepper";
import {
  RadioGroup,
  RadioGroupItem,
} from "../../../../components/ui/radio-group";
import { Label } from "../../../../components/ui/label";
import { Button } from "../../../../components/ui/button";
import { AnimatedTooltip } from "../../../../components/AnimatedTooltip";
import { LucideInfo } from "lucide-react";
import RiskBadge from "./RiskBadge";
import { Textarea } from "../../../../components/ui/textarea";

export function RiskStepContent({
  section,
  sectionIndex,
  setSections,
  sections,
  fetchAnalysis,
  missingQuestions,
  missingTooltipContent,
  handleFinish,
  lastStep,
}) {
  const { nextStep, prevStep, activeStep } = useStepper();

  const handleAnswer = (
    sectionIndex,
    questionIndex,
    value,
    answer_note = false,
  ) => {
    setSections((prev) => {
      const updated = [...prev];
      if (answer_note) {
        updated[sectionIndex].questions[questionIndex].answer_note = value;
      } else {
        updated[sectionIndex].questions[questionIndex].answer = value;
      }
      return updated;
    });
  };

  // ✅ Check if all questions in this section are answered
  const allAnswered = section?.questions?.every((q) => q?.answer);
  return (
    <div className="h-auto flex flex-1 flex-col gap-4">
      <h2 className="text-lg font-semibold">{section.sub_title}</h2>

      <div className="flex flex-col gap-4 h-[490px] overflow-auto bg-muted rounded-md p-2">
        {section?.questions?.map((q, i) => {
          const topic = q?.label?.split("info")[0];
          const info =
            q?.label &&
            q?.label?.split("info")[1] &&
            q?.label?.split("info")[1]?.slice(1);
          const question = q?.question;
          const questionKey = `${section?.title}_${i}`;
          return (
            <div
              key={i}
              className={`border p-3 rounded-md flex flex-col gap-3 bg-background ${missingQuestions?.includes(i) ? "border-webPrimary border-2" : ""}`}
              style={{
                borderColor:
                  q.answer_type != 2
                    ? q.answer === "Yes"
                      ? q?.yes_color
                        ? q?.yes_color
                        : section?.yes_color
                      : q.answer === "No"
                        ? q?.no_color
                          ? q?.no_color
                          : section?.no_color
                        : missingQuestions.includes(i)
                          ? "#0077c7"
                          : undefined
                    : missingQuestions.includes(i)
                      ? "#0077c7"
                      : undefined,
              }}
            >
              <p>
                <div className="flex items-center justify-between">
                  <div className="font-medium flex items-center gap-2">
                    <strong className="mr-1 text-webPrimary">{i + 1}.</strong>
                    {topic}:{" "}
                    {info && (
                      <AnimatedTooltip
                        title={
                          <>
                            <a
                              href={`${info}`}
                              target="_blank"
                              className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 dark:hover:bg-webSecondary transition-colors"
                              rel="noreferrer"
                            >
                              {info}
                            </a>
                          </>
                        }
                        leftAlign={true}
                      >
                        <LucideInfo className="h-4 w-4 text-webPrimary" />
                      </AnimatedTooltip>
                    )}
                  </div>
                  {q.risk ? <RiskBadge value={q.risk} /> : ""}
                </div>
                {question}
              </p>
              {q.answer_type != "note" && (
                <RadioGroup
                  value={q.answer || ""}
                  onValueChange={(value) =>
                    handleAnswer(sectionIndex, i, value)
                  }
                  className="flex gap-6"
                >
                  {["Yes", "No"]?.map((option) => (
                    <div key={option} className="flex items-center space-x-2">
                      <RadioGroupItem
                        value={option}
                        id={`${questionKey}_${option}`}
                      />
                      <Label
                        htmlFor={`${questionKey}_${option}`}
                        className="cursor-pointer"
                      >
                        {option}
                      </Label>
                    </div>
                  ))}
                </RadioGroup>
              )}
              {q.answer_type != "yes_no" && (
                <Textarea
                  name="Enter Answer"
                  rows={4}
                  onChange={(e) =>
                    handleAnswer(sectionIndex, i, e.target.value, true)
                  }
                  value={q.answer_note}
                />
              )}
            </div>
          );
        })}
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-end gap-3 relative">
        {/* <AnimatedTooltip
          title={missingTooltipContent}
          leftAlign={true}
          bottomAlign={false}
          className={"items-end justify-end bottom-10"}
        > */}
        {missingQuestions?.length > 0 && (
          <div className="text-webPrimary relative">
            {missingQuestions.length} question(s) remaining
          </div>
        )}
        {/* </AnimatedTooltip> */}
        {activeStep > 0 && (
          <Button variant="secondary" onClick={prevStep}>
            Previous
          </Button>
        )}

        {!lastStep ? (
          !allAnswered ? (
            <AnimatedTooltip
              title={" Please answer all questions before proceeding"}
            >
              <Button onClick={nextStep} disabled={!allAnswered}>
                Next
              </Button>
            </AnimatedTooltip>
          ) : (
            <Button
              onClick={() => {
                nextStep();
                // if (activeStep === sections.length - 1) {
                //   fetchAnalysis(sections);
                // }
              }}
              disabled={!allAnswered}
            >
              Next
            </Button>
          )
        ) : (
          <Button
            type="submit"
            onClick={() => {
              handleFinish();
            }}
          >
            Submit
          </Button>
        )}
      </div>
    </div>
  );
}
